import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import { logPageImpression } from '../analytics/analytics'
import { logGoogleAnalyticsEvent } from '../analytics/google-analytics'

const params = {
    helpOverlayID: 'item-view-gallery__help-overlay',
    isAdEnabled: true,
    isAdShown: false,
    refreshAdPageModulo: 4,
    galleryPagesVisited: 0,
    adSlot: ''
}

let show_help = null

export default function () {
    show_help = should_show_help_overlay()
    init_photoswipe_from_dom('.item-view-gallery__figure')
}
/**
 * @param {string} gallerySelector
 */
function init_photoswipe_from_dom (gallerySelector) {
    // loop through all gallery elements and bind events
    let $gallery_elements = $(gallerySelector)

    $gallery_elements.each(function (index, element) {
        $(element)
            .data('pswp-uid', index + 1)
            .on('click', on_thumbnail_click)
    })

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    let hashData = parse_location_hash()
    if (hashData.pid > 0 && hashData.gid > 0) {
        open_photoswipe(hashData.pid - 1, $gallery_elements[hashData.gid - 1], true)
    }
}

// parse slide data (url, title, size ...) from DOM elements
// (children of gallerySelector)
function parse_thumbnail_elements (el) {
    let $figures = $('figure', el)
    let figureCount = $figures.length

    let items = []
    let thumb_elements = el.childNodes
    let num_nodes = thumb_elements.length
    let figure_element
    let link_element
    let size
    let item

    for (let i = 0; i < figureCount; i++) {
        figure_element = $figures[i] // <figure> element

        if (figure_element.nodeName !== 'FIGURE') {
            continue
        }

        link_element = figure_element.children[0] // <a> element

        size = link_element.getAttribute('data-size').split('x')

        // create slide object
        item = {
            src: link_element.getAttribute('href'),
            w: parseInt(size[0], 10),
            h: parseInt(size[1], 10)
        }

        if (figure_element.children.length > 1) {
            // <figcaption> content
            item.title = figure_element.children[1].innerHTML
        }

        if (link_element.children.length > 0) {
            // <img> thumbnail element, retrieving thumbnail url
            item.msrc = link_element.children[0].getAttribute('src')
        }

        item.el = figure_element // save link to element for getThumbBoundsFn
        items.push(item)
    }

    return items
}

// find nearest parent element
function closest (el, fn) {
    return el && (fn(el) ? el : closest(el.parentNode, fn))
}

function on_thumbnail_click (event) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false

    let eTarget = event.target

    // find root element of slide
    let clickedListItem = closest(eTarget, function (element) {
        return (element.tagName && element.tagName.toUpperCase() === 'FIGURE')
    })

    if (!clickedListItem) {
        return
    }

    let index = $(clickedListItem).data('galleryIndex')

    let clickedGallery = $('.item-view-gallery__wrapper')[0]

    if (index > 0) {
        // open PhotoSwipe if valid index found
        open_photoswipe(index - 1, clickedGallery)
    }

    return false
}

function parse_location_hash () {
    let hash = window.location.hash.substring(1),
        params = {}

    if (hash.length < 5) {
        return params
    }

    let vars = hash.split('&')
    for (let i = 0; i < vars.length; i++) {
        if (!vars[i]) {
            continue
        }
        let pair = vars[i].split('=')
        if (pair.length < 2) {
            continue
        }
        params[pair[0]] = pair[1]
    }

    if (params.gid) {
        params.gid = parseInt(params.gid, 10)
    }

    if (!params.hasOwnProperty('pid')) {
        return params
    }
    params.pid = parseInt(params.pid, 10)
    return params
}

function open_photoswipe (index, galleryElement, disableAnimation) {
    let pswpElement = document.querySelectorAll('.pswp')[0]
    let gallery
    let options
    let items = parse_thumbnail_elements(galleryElement)

    // define options (if needed)
    options = {
        index: index,
        // top = 44 (default) + 90 (banner) = 134
        barsSize: { top: 135, bottom: 'auto' },

        // define gallery index (for URL)
        galleryUID: galleryElement.getAttribute('data-pswp-uid'),

        getThumbBoundsFn: function (index) {
            // See Options -> getThumbBoundsFn section of documentation for more info
            let thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect()

            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
        }

    }

    if (disableAnimation) {
        options.showAnimationDuration = 0
    }

    options.closeOnScroll = false

    // Pass data to PhotoSwipe and initialize it
    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)

    gallery.listen('afterInit', function () {
        if (show_help) {
            show_help_overlay(1300)
        }
    })
    gallery.listen('afterChange', function () {
        logPageImpression()
        logGoogleAnalyticsEvent('bikemarkt', 'gallery', 'image load')
        params.galleryPagesVisited += 1
        refresh_ad()
    })
    gallery.listen('close', function () {
        destroy_ad()
    })
    gallery.listen('imageLoadComplete', function () {
        render_ad()
    })

    gallery.init()
}

function render_ad () {
    if (!params.isAdEnabled) {
        return
    }
    if (params.isAdShown) {
        refresh_ad()
        return
    }
    if (is_mobile() && $(window).width() > $(window).height()) {
        return
    }

    params.isAdEnabled = false
    params.isAdShown = true

    let $container = $('<div>', { id: 'item-view-gallery__reklame' })
        .css('z-index', '40000')
        .appendTo('body')

    let width = $(window).width()
    let adWidth = 320
    let sizes = [[320, 50]]
    if (width >= 468) {
        sizes.unshift([468, 60])
        adWidth = 468
    }
    if (width >= 728) {
        sizes.unshift([728, 90])
        adWidth = 728
    }
    if (width >= 970) {
        sizes.unshift([970, 90])
        adWidth = 970
    }

    $container.css({
        width: adWidth,
        left: Math.max(0, Math.round((width - adWidth) / 2))
    })

    googletag.cmd.push(function () {
        params.adSlot = googletag
            .defineSlot('/1003531/MTB-News_Bikemarkt_Gallery', sizes, 'item-view-gallery__reklame')
            .addService(googletag.pubads())
            googletag.display('item-view-gallery__reklame')
    })
    if (googletag.pubads().isInitialLoadDisabled()) {
        googletag.pubads().refresh([params.adSlot], { changeCorrelator: false })
    }
}

function destroy_ad () {
    params.isAdShown = false
    $('#item-view-gallery__reklame').remove()
}

function refresh_ad () {
    if (!params.isAdShown) {
        return
    }
    if (params.galleryPagesVisited % params.refreshAdPageModulo !== 0) {
        return
    }

    if (params.adSlot === '') {
        return
    }

    googletag.pubads().refresh([params.adSlot], { changeCorrelator: false })
}

function show_help_overlay (timeout) {
    // don't render again when the gallery is opened a second time
    show_help = false;

    let $overlay = $('<div></div>')
        .attr('id', params.helpOverlayID)
        .attr('class', 'w-10/12 md:w-1/3 mx-auto p-4 rounded-lg bg-slate-200/60 text-black text-center font-bold')
        .css('z-index', '20010') // Photoswipe == 20000
        .text('Tipp: du kannst mit der Tastatur durch die Bilder blättern ')
        .append('<i class="mtb-icon-left"></i> ')
        .append('<i class="mtb-icon-right"></i>')

    $('body').append($overlay)

    $overlay.offset(
        {
            top: Math.round(($(window).height() - $overlay.height()) / 2),
            left: Math.round(($(window).width() - $overlay.width()) / 2)
        }
    ).show()

    window.setTimeout(remove_help_overlay, timeout)
}

function remove_help_overlay () {
    $('#' + params.helpOverlayID).fadeOut(200, function () {
        $(this).remove()
    })
}

/**
 * Help overlay is rendered:
 * 1. the first time the gallery is opened
 * 2. on desktop devices
 *
 * @returns {boolean}
 */
function should_show_help_overlay() {
    if (show_help === false) {
        return false
    }

    return !is_mobile()
}

function is_mobile() {
    return window.innerWidth < 980
}
